import { render, staticRenderFns } from "./LiveLogo.vue?vue&type=template&id=5b5f9f66&scoped=true"
import script from "./LiveLogo.vue?vue&type=script&lang=js"
export * from "./LiveLogo.vue?vue&type=script&lang=js"
import style0 from "./LiveLogo.vue?vue&type=style&index=0&id=5b5f9f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f9f66",
  null
  
)

export default component.exports